<template>
	<div class="login" v-show="showLogin" @click.stop="close()">
		<div class="login-box" @click.stop="">
			<div class="title">
				<img v-show="type=='login'&&userList.length>0" @click="type=''" class="back-btn" src="./img/back.png">
				<img class="logo" src="./img/logo.png">
				<img class="close-btn" @click.stop="close()" src="./img/close-btn.png">
			</div>
			<div class="body">
				<div class="cell">
					<div class="input-box">
						<img src="./img/phone.png">
						<div class="input"><input :disabled="type!='login'" @focusin="userListShow=true"
								@focusout="userListShowSwitch" v-model="phone" />
						</div>
						<div class="history-list" v-show="userListShow&&userList.length>0&&type=='login'">
							<div class="history-item" v-for="(item ,index) in userList" :key="index">
								<span @click="selectHistory(item)">{{item.phone}}</span>
								<span @click="removeHistory(index)" class="history-close-btn"></span>
							</div>
						</div>
					</div>

				</div>

				<div class="cell" v-show="type!='login'">

					<div style="margin-top: 10px;" class="submit" @click="inGame()">进 入 游 戏</div>
				</div>
				<div class="cell" v-show="type=='login'">
					<div class="input-box code-input">
						<img src="./img/lock.png">
						<div class="input"><input v-model="code" /></div>
					</div>
					<div class="code" @click="codeClick()">
						{{text}}
					</div>
				</div>
			</div>
			<div class="foot">
				<div class="submit" v-show="type=='login'" @click="submit()">登 录</div>
				<div v-show="type!='login'">
					<img class="select" @click="select=!select" v-show="select" src="./img/select.png" />
					<img class="select" @click="select=!select" v-show="!select" src="./img/unselect.png" />
					<span>
						同意
						<a @click="openAgreement('privacy')">隐私协议</a>
						及
						<a @click="openAgreement('user')">用户协议</a>
					</span><br /><br />
					<a @click="type='login'">切换账号</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import store from '@/store'
	export default {
		name: "Login",
		data() {
			return {
				phone: '',
				code: '',
				text: '发送验证码',
				showLogin: false,
				timer: null,
				second: 0,
				userListShow: false,
				userList: [],
				type: 'login',
				select: false,
			};
		},
		created() {
			let userList = localStorage.getItem('userList')
			this.userList = JSON.parse(userList)
			this.userList = this.userList ? this.userList : []

		},
		computed: {},
		methods: {
			show(callBack) {
				this.showLogin = true
				document.body.appendChild(this.$el)
				this.submitCallBack = callBack
			},
			close() {
				this.showLogin = false
				this.code = ''
				document.body.removeChild(this.$el)
			},
			async getCode(phone) {
				let res = await store.dispatch('getCode', {
					phone: phone
				})
				if (this.$Api.ok(res)) {
					this.$Toast.show({
						content: '发送成功',
					})
				}
			},
			async submit() {
				if (this.phone.length != 11) {
					return this.$Toast.show('手机号码出错')
				}
				if (this.code.length != 4) {
					return this.$Toast.show('验证码出错')
				}
				let res = await store.dispatch('setLogin', {
					phone: this.phone,
					smsCode: this.code,
					shareUuid: localStorage.getItem('UUID')
				})
				if (this.$Api.ok(res)) {
					this.$Toast.show({
						content: '登录成功',
					})
					store.commit('SET_ACCESS_TOKEN', res[0].data.data.token)
					if (!this.userList.find(item => item.phone == this.phone)) {
						this.userList.unshift({
							phone: this.phone,
							accessToken: res[0].data.data.token
						})
						if (this.userList.length > 3) {
							this.userList = [this.userList[0], this.userList[1], this.userList[2]]
						}
					}
					this.$Login.close()
					this.submitCallBack()
				}
			},
			codeClick() {
				if (this.phone.length != 11) {
					return this.$Toast.show('手机号码出错')
				}
				if (this.second > 0) {
					return this.$Toast.show('不能频繁获取验证码')
				}
				this.second = 60
				this.text = `重新发送（${this.second}）`
				this.timer = setInterval(() => {
					if (this.second <= 0) {
						this.text = `发送验证码`
						clearInterval(this.timer)
						return
					}
					this.second--
					this.text = `重新发送（${this.second}）`
				}, 1000)
				this.getCode(this.phone)
			},
			submitCallBack() {},
			selectHistory(item) {
				this.phone = item.phone
				//store.commit('SET_ACCESS_TOKEN', item.accessToken)
				//localStorage.setItem('accessToken',item.accessToken)
				//this.close()
			},
			removeHistory(index) {
				this.userList = this.userList.filter((item, i) => i != index)
			},
			userListShowSwitch() {
				setTimeout(() => {
					this.userListShow = false
				}, 100)
			},
			inGame() {
				if (!this.select) {
					return this.$Toast.show('请同意相关协议')
				}
				if (this.userList.length > 0) {
					store.commit('SET_ACCESS_TOKEN', '')
					store.commit('SET_ACCESS_TOKEN', this.userList[0].accessToken)
					this.close()
				}
				this.submitCallBack()
			},
			openAgreement(name) {
				let agreement = require('./agreement/' + name + '.js')
				this.$Alert.show(agreement.title, agreement.text)
			}
		},
		watch: {
			userList() {
				localStorage.setItem('userList', JSON.stringify(this.userList))
			},
			type(cv) {
				if (!cv) {
					if (this.userList.length > 0) {
						this.phone = this.userList[0].phone

					} else {
						this.phone = ''
					}
				}
			}
		}
	};
</script>
<style scoped>
	input {
		background: none;
		outline: none;
		border: none;
		width: 100%;
	}

	a {
		text-decoration: underline;
	}

	.login {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.login-box {
		border-radius: 6px;
		width: 80%;
		margin: 0 auto;
		overflow: hidden;
	}

	.title {
		background-color: #ffffff;
		color: #686e3f;
		padding: 12px;
	}

	.logo {
		width: 140px;
	}

	.close-btn {
		width: 20px;
		height: 20px;
		float: right;
	}

	.back-btn {
		width: 20px;
		height: 20px;
		float: left;
	}

	.body {
		background-color: #efe8c2;
		padding: 20px 12px;
	}


	.foot {
		background-color: #ffffff;
		color: #686e3f;
		padding: 16px;
	}

	.submit {
		background-color: #90ba89;
		width: 40%;
		color: white;
		border-radius: 50px;
		margin: 0 auto;
		padding: 6px;
	}

	.cell {
		display: flex;
		padding: 4px 8px;
	}

	.cell .input-box {
		flex: 1;
		background-color: #ffffff;
		border-radius: 60px;
		padding: 4px 12px;
		text-align: left;
		display: flex;
		justify-content: flex-start;
	}

	.cell .input-box img {
		width: 18px;
		height: 24px;
		vertical-align: middle;
		position: relative;
		top: 2px;
	}

	.cell .input-box .input {
		vertical-align: middle;
		border: none;
		flex: 1;
		padding: 6px 6px;
		display: block;
	}

	.code {
		width: auto;
		display: inline-block;
		background-color: #dcce6b;
		border-radius: 60px;
		color: #ffffff;
		line-height: 34px;
		vertical-align: middle;
		text-align: center;
		margin-left: 10px;
		padding: 0 10px;
		font-size: 12px;
	}

	.history-list {

		position: absolute;
		margin-top: 36px;
		width: 59%;
		z-index: 9;
		max-height: 200px;
		box-shadow: 0 2px 12px 0 rgb(0, 0, 0, 0.3);
	}

	.history-item {
		width: 100%;
		padding: 4px 8px;
		width: 100%;
		font-size: 16px;
		background-color: #ffffff;
	}

	.history-close-btn {
		display: inline-block;
		width: 10px;
		height: 10px;
		float: right;
	}

	.history-close-btn::before {
		content: "\2716";
	}

	.select {

		vertical-align: middle;
		width: 18px;
		height: 18px;
	}
</style>
